import { Box, IconButton, makeStyles, Step, StepLabel, Stepper, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import CustomButton from '../../components/CustomButton'
import CustomHeading from '../../components/CustomHeading'
import DealerForm from './DealerForm'
import { Close } from '@material-ui/icons'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import { useFeatures } from '../../hooks/Features/useFeatures'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'

const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
    borderRadius: '50px',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // padding: '0px 178px',
      width: '30%',
      marginTop: '35px',
      //   marginLeft: '20px',
    },
  },
  iconContainer: {
    color: 'white',
    fontSize: '27px',
  },
  stepContent: {
    // marginTop: '15px',
  },
  heading: { fontWeight: 'bold', textAlign: 'center', marginBottom: '15px' },
}))

function getSteps() {
  return ['Add dealer', 'Add Location', 'KYC']
}

export default function AddDealer( {handleClose, input, state, setState, level, handleSubmit, handleNext }) {
  const classes = useStyles()

  return (
    <div>
      <CustomAddForm data = {input} state = {state} setState = {setState}/>
      
    </div>
  )
}
